import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MyFitmentsComponent } from './my-fitments.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'fitments',
        component: MyFitmentsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'fitments'] },
        resolve: { permissions: PermissionsResolver}
      },
      {
        path: 'fitments-library',
        component: MyFitmentsComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'fitments'] },
        resolve: { permissions: PermissionsResolver}
      },
      {
        path: 'fitments/:id',
        pathMatch: 'full',
        redirectTo: 'product-details-v2/:id/fitments',
        data: { permissions: ['admin', 'fitments'] },
        resolve: { permissions: PermissionsResolver}
      },
    ])
  ],
  exports: [RouterModule],
})
export class MyFitmentsRoutingModule {}
